// extracted by mini-css-extract-plugin
module.exports = {"InformationalBoxHeavy":"InformationalBoxHeavy_InformationalBoxHeavy__3PbBu","InformationalBoxHeavy_title":"InformationalBoxHeavy_InformationalBoxHeavy_title__352zb"};